module.exports = __webpack_public_path__ + "img/blocking.ef2efe56.svg";